/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ParentCompanyAndLocation/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomSysOrganizationsParentCompanyLocationSelect from 'DesignSystem/DataVaxiomSysOrganizationsParentCompanyLocationSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ParentCompanyAndLocation({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentCard/ParentCompanyAndLocation",
  onChange
  
}) {
let selectedChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
})
  return (<React.Fragment
>
<DataVaxiomSysOrganizationsParentCompanyLocationSelect
  viewPath={`${viewPath}/DataVaxiomSysOrganizationsParentCompanyLocationSelect`}
 data="selected"
 onChange={selectedChangeData}
/>
{children}
</React.Fragment>)
}